import { CONTACT_API } from 'modules/contacts/api/contact-api'
import { ContactPageSwrInterface } from 'modules/contacts/contact-page/types/contact-page-filter-interface'
import { ContactPaymentsApiInterface } from 'modules/contacts/contact-page/types/contact-payments-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'

export function useContactPayments({
  limit,
  pagination,
  filter,
  contactId,
  shouldFetch,
}: ContactPageSwrInterface) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, ContactPaymentsApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const filterApi = `${filter.date[0] ? `&filter[dateSince]=${filter.date[0]}` : ''}${
    filter.date[1] ? `&filter[dateTill]=${filter.date[1]}` : ''
  }`

  const { data: contactPayments, mutate } = useSWR(() => {
    if (user && shouldFetch && pagination.startFromId === undefined && limit) {
      return `${CONTACT_API}/contacts/${contactId}/payments?pagination[limit]=${limit}${filterApi}`
    } else if (user && shouldFetch && pagination.startFromId && limit) {
      return `${CONTACT_API}/contacts/${contactId}/payments?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}${filterApi}`
    }
    return null
  }, fetcher)

  return { contactPayments, mutate }
}
